import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/store/store';
import { Derivation } from '@/pages/SILA/interfaces/Derivation';
import { DerivationStatus } from '@/pages/SILA/enums/DerivationStatus';
import derivationsService, {
  useUpdateDerivationMutation,
} from '@/pages/SILA/services/derivations.service';
import { UpdateDerivation } from '../interfaces/UpdateDerivation';

export const useDerivationActions = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [updateDerivation] = useUpdateDerivationMutation();
  const [isTaking, setIsTaking] = useState(false);
  const [isFinishing, setIsFinishing] = useState(false);

  const takeDerivation = async (derivation: Derivation, userId: string) => {
    setIsTaking(true);
    try {
      const current = await dispatch(
        derivationsService.endpoints.getDerivation.initiate(derivation.id)
      ).unwrap();

      if (current.status !== DerivationStatus.PENDING) {
        throw new Error('La derivación ya ha sido asignada por otro usuario.');
      }

      const newData: UpdateDerivation = {
        status: DerivationStatus.ASSIGNED,
        user: userId,
      };

      const response = await updateDerivation({
        derivationId: derivation.id,
        data: newData,
      }).unwrap();

      return response;
    } catch (error) {
      console.error('Error al tomar la derivación:', error);
      throw error;
    } finally {
      setIsTaking(false);
    }
  };

  const finishDerivation = async (derivationId: string) => {
    setIsFinishing(true);
    try {
      const response = await updateDerivation({
        derivationId,
        data: { status: DerivationStatus.FINISHED },
      }).unwrap();

      return response;
    } catch (error) {
      console.error('Error al finalizar la derivación:', error);
      throw error;
    } finally {
      setIsFinishing(false);
    }
  };

  return {
    takeDerivation,
    isTaking,
    finishDerivation,
    isFinishing,
  };
};
